import React, { useState } from 'react';
import { createContact, updateContact } from '../../../lib/api';
import { CalendlyEventListener, openPopupWidget } from 'react-calendly';
import { LoadingIcon } from '../LoadingIcon';
import InputField from 'stories/InputField';
import { PhoneField } from 'stories/PhoneField';
import { HierarchyPrimary, Primary } from 'stories/Button.stories';
import { FiPhoneCall } from 'react-icons/fi';

const HireForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    designation: '',
    // formType: "hire",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formSuccess, setFormSuccess] = useState(false);

  const handleInputChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const { name, email, phone } = formData;
    if (!name || !email || !phone) {
      setError('Please fill name, email and mobile');
      return;
    }
    const regEx =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!email.match(regEx)) {
      setError('Error: Please enter correct email');
      return;
    }
    if (
      email.includes('@gmail.com') ||
      email.includes('@yahoo.com') ||
      email.includes('@aol.com') ||
      email.includes('@outlook.com')
    ) {
      setError('Error: This domain is not allowed.');
      return;
    }
    if (name && email && phone) {
      try {
        setLoading(true);
        // await axios.post(`${apiBaseUrl}/api/forms`, {
        //   data: formData,
        // });
        const { body } = await createContact({
          ...formData,
          phone: `+91${formData.phone}`,
        });
        setFormData({
          ...formData,
          id: body.id,
          phone: `+91${formData.phone}`,
        });
        setError('');
        setFormSuccess(true);
        setLoading(false);
      } catch (error) {
        setError('Validation error. Please fill the form correctly.');
        setFormSuccess(false);
        setLoading(false);
      }
      return;
    }
  };

  const handleBookMeeting = (event) => {
    event.preventDefault();
    openPopupWidget({
      url: process.env.NEXT_PUBLIC_CALENDLY_URL || 'https://calendly.com/anshit-verma/15min',
      prefill: {
        name: formData.name,
        email: formData.email,
        customAnswers: {
          a2: formData.phone,
        },
      },
    });
  };

  const onEventScheduled = async (e) => {
    if (e.data.event === 'calendly.event_scheduled') {
      const eventURI = e.data.payload.event.uri;
      await updateContact({ id: formData.id, eventURI });
    }
  };

  return (
    <div className="relative z-10 rounded-lg bg-white p-[24px]">
      {!loading && formSuccess ? (
        <div className="flex flex-col items-center justify-center p-8 font-satoshi-medium text-xl font-medium ">
          <img src="/assets/icons/checked.png" alt="" className="mb-2 h-[60px] w-[60px]" />
          <div className="my-2 text-center font-satoshi-medium text-lg">
            Thank you for showing interest.{' '}
          </div>
          <div className="mb-2 text-center font-satoshi-medium text-lg">
            Our placements team will get in touch with you.
          </div>
          <div
            className="my-6 w-full"
            style={{
              border: '0.025rem solid #E4E4E4',
              background: '#E4E4E4',
            }}
          ></div>
          <div className="mb-2 text-center font-satoshi-medium text-lg">
            Meanwhile, you can also book a meeting with our placement manager.
          </div>
          <Primary label={'Book a meeting'} size={'xl'} onClick={handleBookMeeting} />
          <CalendlyEventListener onEventScheduled={onEventScheduled} />

          <div className="mt-8 flex w-full flex-col items-center gap-y-[4px]">
            <p className="font-satoshi-bold text-[18px] leading-7">Have Questions?</p>
            <HierarchyPrimary
              linkCTA
              label={'Call 9902156768'}
              href={'tel:9902156768'}
              customStyle={'flex-row-reverse text-[#3470E4] hover:text-[#3470E4]'}
            >
              <div className="rounded-full bg-[#1A9FBD] p-[8px]">
                <FiPhoneCall size={16} color="white" />
              </div>
            </HierarchyPrimary>
          </div>
        </div>
      ) : (
        <form className="flex flex-col gap-y-[16px]">
          <h6 className="font-satoshi-bold text-[20px] leading-[30px]">
            Schedule a demo call with our placement team
          </h6>
          <InputField
            inputStyle="!rounded-lg !border !border-gray-3 !py-[8px] !px-[12px]"
            type="text"
            name="name"
            value={formData.name}
            placeholder="Enter Full Name"
            onChange={(e) => handleInputChange('name', e.target.value)}
            label="Name"
          />

          <InputField
            inputStyle="!rounded-lg !border !border-gray-3 !py-[8px] !px-[12px]"
            type="email"
            name="email"
            value={formData.email}
            placeholder="Work Email"
            onChange={(e) => handleInputChange('email', e.target.value)}
            label="Work Email"
          />

          <div>
            <PhoneField
              name="phone"
              placeholder="Mobile Number"
              className="!rounded-lg !border !border-gray-3 !py-[4px] !px-[12px]"
              countryCodeStyle={'text-gray-400 sm:text-sm'}
              phoneInputContainerStyle="sm:text-sm"
              value={formData.phone}
              onChange={(e) => handleInputChange('phone', e.target.value)}
              label="Phone Number"
              labelStyle={'my-2 text-xs capitalize text-gray-dark'}
            />
          </div>

          <InputField
            inputStyle="!rounded-lg !border !border-gray-3 !py-[8px] !px-[12px]"
            type="text"
            name="company"
            value={formData.company}
            placeholder="Company Name"
            onChange={(e) => handleInputChange('company', e.target.value)}
            label="Company Name"
          />

          <InputField
            inputStyle="!rounded-lg !border !border-gray-3 !py-[8px] !px-[12px]"
            type="text"
            name="designation"
            value={formData.designation}
            placeholder="Designation"
            onChange={(e) => handleInputChange('designation', e.target.value)}
            label="Designation"
          />

          {!loading && error && <div className="text-sm text-red">{error}</div>}

          <Primary
            type="submit"
            label={''}
            onClick={(e) => handleFormSubmit(e)}
            disabled={loading}
            size={'xl'}
          >
            {loading ? <LoadingIcon className="text-red" /> : 'Submit'}
          </Primary>
        </form>
      )}
    </div>
  );
};

export default HireForm;

// import React, { useState } from 'react';
// import Image from 'next/image';
// import { createContact, updateContact } from '@lib/api';
// import { CalendlyEventListener, openPopupWidget } from 'react-calendly';
// import { LoadingIcon } from '../LoadingIcon';

// const HireForm = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     company: '',
//     phone: '',
//     designation: '',
//     // formType: "hire",
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [formSuccess, setFormSuccess] = useState(false);

//   const handleInputChange = (key, value) => {
//     setFormData((prevState) => ({
//       ...prevState,
//       [key]: value,
//     }));
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     const { name, email, phone } = formData;
//     if (!name || !email || !phone) {
//       setError('Please fill name, email and mobile');
//       return;
//     }
//     const regEx =
//       /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
//     if (!email.match(regEx)) {
//       setError('Error: Please enter correct email');
//       return;
//     }
//     if (
//       email.includes('@gmail.com') ||
//       email.includes('@yahoo.com') ||
//       email.includes('@aol.com') ||
//       email.includes('@outlook.com')
//     ) {
//       setError('Error: This domain is not allowed.');
//       return;
//     }
//     try {
//       setLoading(true);
//       // await axios.post(`${apiBaseUrl}/api/forms`, {
//       //   data: formData,
//       // // });
//       const { body } = await createContact({
//         ...formData,
//         phone: `+91${formData.phone}`,
//       });
//       console.log(body);
//       setFormData({
//         ...formData,
//         // id: body.id,
//         phone: `+91${formData.phone}`,
//       });
//       setError('');
//       setFormSuccess(true);
//       setLoading(false);
//     } catch (error) {
//       console.log(error);
//       setError('Validation error. Please fill the form correctly.');
//       setFormSuccess(false);
//       setLoading(false);
//     }
//   };

//   const handleBookMeeting = (event) => {
//     event.preventDefault();
//     openPopupWidget({
//       url: process.env.NEXT_PUBLIC_CALENDLY_URL || 'https://calendly.com/anshit-verma/15min',
//       prefill: {
//         name: formData.name,
//         email: formData.email,
//         customAnswers: {
//           a2: formData.phone,
//         },
//       },
//     });
//   };

//   const onEventScheduled = async (e) => {
//     if (e.data.event === 'calendly.event_scheduled') {
//       const eventURI = e.data.payload.event.uri;
//       await updateContact({ id: formData.id, eventURI });
//     }
//   };

//   return (
//     <div className={`grid w-full gap-8 bg-[#FBF8F7] p-6 py-12 md:grid-cols-6 md:p-12 lg:w-full`}>
//       <div className="col-span-3 md:p-8">
//         <section className="mb-14">
//           <h2 className="text-3xl">Why Hire from us</h2>
//           <p className="my-2 text-sm text-gray-dark">
//             Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
//             has been the industry's{' '}
//           </p>
//         </section>
//         <div className="grid w-full grid-flow-row grid-cols-2 gap-8 mt-2 gap-y-12 md:w-auto">
//           {[
//             'Zero Cost Hiring',
//             'Industry Certified Candidates',
//             'TAT < 1 week',
//             'Pre Assessed Top Talent',
//           ].map((name, index) => (
//             <div key={name} className="rounded-md">
//               <Image
//                 src={`/assets/images/hire-from-us/hire-form-icon-${index + 1}.png`}
//                 alt="icon"
//                 height={50}
//                 width={50}
//                 loading="lazy"
//               />
//               <div className="mt-1 text-lg font-satoshi-medium font-medium ">{name}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//       <div className="h-full col-span-3 p-8 bg-white border border-white rounded-md">
//         {!loading && formSuccess ? (
//           <div className="flex flex-col items-center justify-center p-8 text-xl font-satoshi-medium font-medium ">
//             <img src="/assets/icons/checked.png" alt="" className="mb-2 h-[60px] w-[60px]" />
//             <div className="my-2 text-lg font-extrabold text-center">
//               Thank you for showing interest.{' '}
//             </div>
//             <div className="mb-2 text-lg text-center font-extralight text-gray-dark">
//               Our placements team will get in touch with you.
//             </div>
//             <div
//               className="w-full my-6"
//               style={{
//                 border: '0.025rem solid #E4E4E4',
//                 background: '#E4E4E4',
//               }}
//             ></div>
//             <div className="mb-2 text-base font-thin text-center opacity-80">
//               Meanwhile, you can also book a meeting with our placement manager.
//             </div>
//             <button
//               className="px-4 py-2 mt-4 font-satoshi-medium font-medium  text-white rounded-sm text-md w-fit whitespace-nowrap bg-red lg:py-2 lg:px-10 lg:text-lg"
//               onClick={handleBookMeeting}
//             >
//               <div>Book a meeting</div>
//             </button>
//             <CalendlyEventListener onEventScheduled={onEventScheduled} />
//           </div>
//         ) : (
//           <>
//             <div id="hire-form" className="text-xl font-satoshi-bold font-bold  text-center scroll-mt-28 lg:text-left">
//               Schedule a demo call with our placement team 👋
//             </div>
//             {!loading && error && <div className="my-4 text-sm capitalize text-red">{error}</div>}
//             <input
//               type="text"
//               name="name"
//               id="name"
//               value={formData.name}
//               onChange={(e) => handleInputChange('name', e.target.value)}
//               className="block w-full h-12 pr-12 my-4 rounded-md border-gray-border pl-7 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//               placeholder="Name"
//               style={{ border: '1px solid #C6C6C6' }}
//             />
//             <input
//               type="email"
//               name="email"
//               id="email"
//               value={formData.email}
//               onChange={(e) => handleInputChange('email', e.target.value)}
//               className="block w-full h-12 pr-12 my-4 rounded-md border-red pl-7 sm:text-sm"
//               placeholder="Work Email"
//               style={{ border: '1px solid #C6C6C6' }}
//             />
//             {/* <PhoneInput
//               placeholder='Mobile Number'
//               country='IN'
//               value={formData.mobile}
//               onChange={(e) => handleInputChange("mobile", e.target.value)}
//               className='block w-full h-12 pr-12 my-4 rounded-md focus:ring-indigo-500 focus:border-indigo-500 pl-7 sm:text-sm border-gray-border'
//               style={{ border: "1px solid #C6C6C6" }}
//             /> */}
//             <input
//               type="tel"
//               name="phone"
//               id="phone"
//               value={formData.phone}
//               onChange={(e) => handleInputChange('phone', e.target.value)}
//               className="block w-full h-12 pr-12 my-4 rounded-md border-gray-border pl-7 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//               placeholder="Mobile Number"
//               style={{ border: '1px solid #C6C6C6' }}
//             />
//             <input
//               type="text"
//               name="company"
//               id="company"
//               value={formData.company}
//               onChange={(e) => handleInputChange('company', e.target.value)}
//               className="block w-full h-12 pr-12 my-4 rounded-md border-gray-border pl-7 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//               placeholder="Company Name"
//               style={{ border: '1px solid #C6C6C6' }}
//             />
//             <input
//               type="text"
//               name="designation"
//               id="designation"
//               value={formData.designation}
//               onChange={(e) => handleInputChange('designation', e.target.value)}
//               className="block w-full h-12 pr-12 my-4 rounded-md border-gray-border pl-7 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//               placeholder="Designation"
//               style={{ border: '1px solid #C6C6C6' }}
//             />
//             <button
//               disabled={loading}
//               type="submit"
//               className="w-full py-3 my-4 text-lg border-2 rounded-md border-red text-red"
//               onClick={(e) => handleFormSubmit(e)}
//             >
//               {loading ? <LoadingIcon className="text-red" /> : 'Submit'}
//             </button>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default HireForm;
